import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_component_font_awesome_icon, {
    class: _normalizeClass([
			'cursor-pointer',
			{ 'c-icon-left-right--left': _ctx.isLeft },
			{ 'c-icon-left-right--right': !_ctx.isLeft },
			{ 'c-icon-left-right--disabled': _ctx.disabled },
		]),
    icon: _ctx.faChevronLeft.iconName
  }, null, 8, ["class", "icon"]))
}